import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

/**
 * Base API for the AI Translation Risk Assessment UI (AITRAS). Features inject
 * their own endpoints via `injectEndpoints`.
 *
 * The bearer token is attached by `baseQueryWithReauth`, which also handles
 * 401 (silent renew + retry, else re-login) and 403 (forbidden flag).
 */
export const aitrasApi = createApi({
  reducerPath: 'aitrasApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'User',
    'Factors',
    'Assessment',
    'FactorConfig',
    'CustomFactors',
    'LlmConnectorConfig',
    'LlmConnectors',
  ],
  endpoints: () => ({}),
});
